<!-- 教师评价列表 -->
<template>
    <div class="el-TeacherEvaluateList">
        <el-row class="page_content">
            <h1 class="head_title">教师评价</h1>
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="是否填写">
                    <el-select v-model="form.teaEvaluateStudentStatus" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <el-option label="所有" value=""></el-option>
                        <el-option label="已填写" value="1"></el-option>
                        <el-option label="未填写" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="teaEvaluateTitle"
                    header-align="center"
                    align="center"
                    label="标题">
                </el-table-column>
                <el-table-column
                    prop="teacherName"
                    header-align="center"
                    align="center"
                    width="180"
                    label="教师姓名">
                </el-table-column>
                <el-table-column
                    prop="teaEvaluateRequired"
                    header-align="center"
                    align="center"
                    width="180"
                    label="是否必填">
                    <template slot-scope="scope">
                        <template v-if="scope.row.teaEvaluateRequired == 1">
                            <span style="color: red;">是</span>
                        </template>
                        <template v-if="scope.row.teaEvaluateRequired == 2">
                            <span style="color: #409EFF;">否</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="teaEvaluateStudentUpdateTime"
                    header-align="center"
                    align="center"
                    width="180"
                    label="填写时间">
                </el-table-column>
                <el-table-column
                    prop="teaEvaluateStudentStatus"
                    header-align="center"
                    align="center"
                    width="100"
                    label="填写状态">
                    <template slot-scope="scope">
                        <template v-if="scope.row.teaEvaluateStudentStatus == 1">
                            <span style="color: #409EFF;">已填写</span>
                        </template>
                        <template v-else-if="scope.row.teaEvaluateStudentStatus == 2">
                            <span style="color: orange;">待填写</span>
                        </template>
                        <template v-else>
                            <span style="color: orange;">待填写</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    width="150"
                    label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.teaEvaluateStudentStatus == 1">
                            <el-link type="primary" :underline="false" @click="selectData(scope.row)">查看</el-link>
                        </template>
                        <template v-else-if="scope.row.teaEvaluateStudentStatus == 2 || scope.row.teaEvaluateStudentStatus == null">
                            <el-link type="primary" :underline="false" @click="selectData(scope.row)">立即填写</el-link>
                        </template>
                        <template v-else>
                            <span style="color: orange;">待填写</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="text-align: center;position: absolute;bottom: 0;width: 96%;margin-bottom: 20px;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1"
                    :page-size="limit"
                    :hide-on-single-page="true"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </el-row>

        <!-- 教师评价编辑预览对话框 -->
        <el-dialog
            title="教师评价"
            top="20px"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="1000px"
            >
            <h2 style="text-align: center;margin-top: 0;">{{teacherEvaluateInfo.teaEvaluateTitle}}</h2>
            <p style="color: #409eff;">教师姓名：{{teacherEvaluateInfo.teacherName}}</p>
            <div class="teacherEvaluateInfoClass">
                <el-table
                    :data="teacherEvaluateInfo.teacherEvaluateItemList"
                    border
                    style="width: 100%">
                    <el-table-column align="center" prop="itemName" label="测评项目" width="230"></el-table-column>
                    <el-table-column align="left" header-align="center" prop="itemDesc" label="测评内容" ></el-table-column>
                    <el-table-column align="center" prop="teacherEvaluateGradeList" width="180" :label="teacherEvaluateInfo.chooseGrade == 0?'测评分数':'测评等级'">
                        <template slot-scope="scope">
                            <!-- chooseGrade:是否选择等级(0不需要  1需要) -->
                            <template v-if="teacherEvaluateInfo.chooseGrade == 0">
                                <el-input type="text" :disabled="isCompleted" @input="numValid(scope.row.teaEvaluateItemId)" v-model="teacherEvaluateStudentListMap[scope.row.teaEvaluateItemId]" placeholder="请输入分值"></el-input>
                            </template>
                            <template v-else>
                                <el-select style="text-align: center;" :disabled="isCompleted" v-model="teacherEvaluateStudentListMap[scope.row.teaEvaluateItemId]" placeholder="请选择">
                                    <el-option
                                      v-for="item in teacherEvaluateInfo.teacherEvaluateGradeList"
                                      :key="item.teaEvaluateGradeId +'teacherEvaluateGradeList'"
                                      :label="item.gradeName"
                                      :value="item.teaEvaluateGradeId">
                                    </el-option>
                                </el-select>
                            </template>
                        </template>
                    </el-table-column>
                  </el-table>
            </div>
            <p style="margin-bottom: 5px;">说明：</p>
            <div class="teaEvaluateDesc" v-html="teacherEvaluateInfo.teaEvaluateDesc"></div>
            <p style="margin: 5px 0 0;color: red;">(注意: 请认真客观评价，提交后将无法更改)</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <template v-if="isCompleted">
                    <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
                </template>
                <template v-else>
                    <el-button type="primary" @click="submitInfo">确 定</el-button>
                </template>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
  name: "TeacherEvaluateList",
  data() {
    return {
      form:{
          teaEvaluateStudentStatus:""
      },
      tableData: [],
      submitBut:false,
      currentPage1: 1,
      total: 0,
      limit:6,
      page:1,
      teacherEvaluateInfo:{} ,//教师评价详情
      dialogVisible:false,
      teacherEvaluateStudentListMap:{},//整理成map数据
      isCompleted:false, //是否已填
    };
  },
  created() {
    this.getSurveyList();
  },
  methods: {
      handleSizeChange(val) {
          console.log(`每页 ${val} 条`);
          this.limit = val;
          this.getSurveyList();
      },
      handleCurrentChange(val) {
          console.log(`当前页: ${val}`);
          this.page = val;
          this.getSurveyList();
      },
    getSurveyList(){ //获取List
        let param = this.form;
        param.limit = this.limit;
        param.page = this.page;
      this.$store.dispatch("user/getTeacherEvaluateList",this.form).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.tableData = ret.data;
          this.total = ret.count;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      })
    },
    selectScore(v){
      this.getSurveyList();
    },
    selectData(item){ //立即填写或者查看
        this.teacherEvaluateStudentListMap = {};
        this.isCompleted = false;
        // this.$router.push({name: 'TeacherEvaluateView', query: { idInfo: item.teaEvaluateId }});
        this.getTeacherEvaluate(item.teaEvaluateId);
    },
    getTeacherEvaluate(teaEvaluateId){ //获取详细信息
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$store.dispatch("user/getTeacherEvaluate",{teacherEvaluateId:teaEvaluateId}).then((ret) => {
        loading.close();
        if (ret.code === 0 || ret.code === '0') {
            this.teacherEvaluateInfo = ret.data;
            //已填过
            if(!this.$isEmpty(ret.data.teacherEvaluateStudentList) && ret.data.teacherEvaluateStudentList.length > 0){
                this.isCompleted = true;
                for(let i=0;i<ret.data.teacherEvaluateStudentList.length;i++){ //反显数据
                    let teaEvaluateItemId = ret.data.teacherEvaluateStudentList[i].teaEvaluateItemId;
                    let teaEvaluateGradeId = ret.data.teacherEvaluateStudentList[i].teaEvaluateGradeId;
                    this.teacherEvaluateStudentListMap[teaEvaluateItemId] = teaEvaluateGradeId;
                }
                this.teacherEvaluateStudentListMap = Object.assign({},this.teacherEvaluateStudentListMap);
            }
            this.dialogVisible = true;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      }).catch((error) => {
          this.$message({
             message: "接口请求失败！",
             type: 'warning'
          });
          console.log(error)
        loading.close();
      });
    },
    submitInfo(){ //提交数据
        let param = {
            teacherEvaluateStudentList:[],
            teaEvaluateId:this.teacherEvaluateInfo.teaEvaluateId
        };
        let len = this.teacherEvaluateInfo.teacherEvaluateItemList.length; //总共需要选择的长度
        let onlen = Object.keys(this.teacherEvaluateStudentListMap).length; //已选择的长度
        if(len != onlen){
            this.$message.warning(this.teacherEvaluateInfo.chooseGrade == 0?"存在测评分数未填写，请填写！":"测评等级存在未选项，请选择！");
            return;
        }
        for(let key in this.teacherEvaluateStudentListMap){ //整合参数，变成自己想要的样子
            param.teacherEvaluateStudentList.push({
                teaEvaluateItemId:key,
                teaEvaluateGradeId:this.teacherEvaluateStudentListMap[key],
            });
            if(this.teacherEvaluateStudentListMap[key] == null || this.teacherEvaluateStudentListMap[key] == ""){
                this.$message.warning(this.teacherEvaluateInfo.chooseGrade == 0?"存在测评分数未填写，请填写！":"测评等级存在未选项，请选择！");
                return;
            }
        }
        this.$confirm('是否确定提交，提交后将无法进行修改?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/saveTeacherEvaluate",param).then((ret) => {
              loading.close();
              if (ret.code === 0 || ret.code === '0') {
                  this.$message.success("保存成功！");
                  this.getSurveyList();
                  this.dialogVisible = false;
                  //this.getTeacherEvaluate(this.teacherEvaluateInfo.teaEvaluateId);
              } else {
                this.$message({
                   message: ret.msg,
                   type: 'warning'
                });
              }
            }).catch((error) => {
                this.$message({
                   message: "接口请求失败！",
                   type: 'warning'
                });
              loading.close();
            });
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '取消提交'
            });
        });

    },
    numValid(teaEvaluateItemId) {
        this.teacherEvaluateStudentListMap[teaEvaluateItemId] = this.teacherEvaluateStudentListMap[teaEvaluateItemId].replace(/[^0-9]/g, ''); // 移除非数字字符
         if (parseInt(this.teacherEvaluateStudentListMap[teaEvaluateItemId], 10) > 100) {
            this.teacherEvaluateStudentListMap[teaEvaluateItemId] = '100'; // 如果超过100，设置为100
        } else if (parseInt(this.teacherEvaluateStudentListMap[teaEvaluateItemId], 10) < 1) {
            this.teacherEvaluateStudentListMap[teaEvaluateItemId] = '1'; // 如果小于1，设置为1
        }
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-TeacherEvaluateList{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
    .el-descriptions-item__container{
        font-size: 17px;
    }
    .el-descriptions-item__label {
        white-space: nowrap;
        width: 140px;
        text-align: right;
    }
    .el-descriptions-item__content{
        max-height: 200px;
        overflow: auto;
    }
    .teacherEvaluateInfoClass{
       .el-table .el-table__cell{
           padding:5px 0;
       }
    }
    .teaEvaluateDesc{
        p{
            margin: 5px 0;
        }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/teacherEvaluate/TeacherEvaluateList.vue